import { request } from './index'

const getUrlParam = (name: string) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return ''
}

const id = getUrlParam('id')?.toString()

/**
 * 获取订单详情
 * @returns 返回订单信息
 */
export const GetPayOrderInfo = async () => {
  const res = await request({
    method: 'get',
    data: {},
    url: `/api/PayLink/info?pay_link_no=${id}`,
    headers: {}
  })
  return res?.data as any
}

/**
 * 创建订单
 * @param data 校验接口参数
 * @returns 返回校验结果
 */
interface CreateOrderParams {
  pay_link_no: string
  email: string
  out_user_name: string
  phone_number: string
  remark: string
}
export const CreatePayOrder = async (data: CreateOrderParams) => {
  const res = await request({
    method: 'post',
    data,
    url: '/api/PayLink/payin',
    headers: {}
  })
  return res?.data as any
}